module.exports = __webpack_public_path__ + "static/graphik-semibold-b2335e059bb34c710539645b19392d6c.woff";